import script from "./BookingItemPricing.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingItemPricing.vue?vue&type=script&setup=true&lang=ts"

import "./BookingItemPricing.vue?vue&type=style&index=0&id=d659f53e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d659f53e"]])

export default __exports__